import * as React from 'react';

import { Share } from 'react-feather';

import { useShareLink } from '../hooks/useShareLink';

interface Props {
  url: string;
  shareText: string;
  context: string;
  title: string;
}

export const SharePageButton: React.FC<Props> = ({
  url,
  shareText,
  context,
  title,
}) => {
  const handleShare = useShareLink({ url, shareText, context });

  return (
    <button
      title={title}
      onClick={handleShare}
      className="text-white self-start ml-4"
    >
      <Share className="w-5 h-5" />
    </button>
  );
};
